import type { Components } from '@mui/material'

const MuiButtonBase: Components['MuiButtonBase'] = {
  defaultProps: {
    disableRipple: true,
  },
}

export default MuiButtonBase
